(() => {
  const loader = document.getElementById("page-loader");

  if (!loader) return;

  const MIN_DISPLAY_TIME = 850;
  const STORAGE_KEY = "pageLoaderStartedAt";

  let hideTimer;

  function showLoader() {
    clearTimeout(hideTimer);

    const startedAt = Date.now();

    sessionStorage.setItem(STORAGE_KEY, startedAt.toString());

    loader.classList.add("is-visible");
    loader.setAttribute("aria-hidden", "false");
  }

  function hideLoader() {
    clearTimeout(hideTimer);

    const storedTime = Number(sessionStorage.getItem(STORAGE_KEY));
    const startedAt = storedTime || Date.now();
    const elapsed = Date.now() - startedAt;
    const remaining = Math.max(0, MIN_DISPLAY_TIME - elapsed);

    hideTimer = setTimeout(() => {
      loader.classList.remove("is-visible");
      loader.setAttribute("aria-hidden", "true");

      sessionStorage.removeItem(STORAGE_KEY);
    }, remaining);
  }

  function shouldLoadLink(link, event) {
    if (!link || !link.href) return false;

    const url = new URL(link.href, window.location.href);

    if (event.defaultPrevented) return false;
    if (event.button !== 0) return false;

    if (
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return false;
    }

    if (link.target === "_blank") return false;
    if (link.hasAttribute("download")) return false;
    if (link.hasAttribute("data-no-page-loader")) return false;

    if (url.origin !== window.location.origin) return false;

    if (
      url.pathname === window.location.pathname &&
      url.search === window.location.search &&
      url.hash
    ) {
      return false;
    }

    if (
      url.pathname.startsWith("/cart") ||
      url.pathname.startsWith("/checkout")
    ) {
      return false;
    }

    return true;
  }

  document.addEventListener("click", (event) => {
    const link = event.target.closest("a");

    if (!shouldLoadLink(link, event)) return;

    showLoader();
  });

  window.addEventListener("beforeunload", () => {
    loader.classList.add("is-visible");
  });

  window.addEventListener("load", hideLoader);

  window.addEventListener("pageshow", hideLoader);
})();